<template>
    <div class="title">
        <!-- <h1> {{ $t('loginTitle') }} </h1> -->
        <p v-if="message">
            {{ message }}
            <i class="el-icon-loading"></i>
        </p>
        <el-card v-else  class="form">
            <h2> {{ $t('changePasswordMessage') }} </h2>
            <input-field
                :typeField="passwordType"
                :label="$t('usersFormPassword')"
                :error="error.password ? error.password[0] : '' "
                v-model="password"
            />
            <input-field
                :typeField="passwordType"
                :label="$t('usersFormPasswordConfirm')"
                v-model="passwordConfirm"
            />
            <small @click="passwordType==='password' ? passwordType = 'text' : passwordType= 'password'">{{$t('showPassword')}}</small>
            <br>
            <shared-buttons discardPath="Index" :isEdit="true" @confirm-event-fired="sendResetRequest"></shared-buttons>
        </el-card>
    </div>
</template>

<script>
import InputField from '@/components/Inputs/InputField'
import SharedButtons from '@/components/Shared/SharedButtons'
import api from '@/api/api'
import { logout } from '@/helpers/helpers'

export default {
    components: {
        InputField,
        SharedButtons
    },
    data () {
        return {
            error: {},
            message: '',
            password: '',
            passwordConfirm: '',
            passwordType: 'password',
            token:  this.$route.params.token
        }
    },
    methods: {
        logout,
        async sendResetRequest () {
            let response
            await api.changePassword({password: this.password, password_confirmation: this.passwordConfirm})
            .then((res) => {
                response = res
            })
            .catch((err) => {
                let { data } = err                
                this.error = data.fields
                console.log('error', this.error);
                
            })
            if (response && response.status === 200) {
                this.message = this.$t('passwordChangedMessage')
                setTimeout(() => { this.logout({name: 'Home'}) }, 3000)
            }
        },
        async sendResetTokenRequest () {
            await api.resetPasswordToken(this.token, this.password, this.passwordConfirm)
            .then((res) => {
                if (res.status === 200) {
                    this.$router.push({name: 'Index'})
                }
            })
            .catch((err) => {
                let { data } = err                
                this.error = data.fields
            })
        }
    }
}
</script>

<style scoped>
.title {
        text-align: center;
        padding: 10px;
        margin-top: 36px;
    }
.form {
        text-align: center;
        /* margin-top: 30px;
        margin-bottom: 0px;
        padding: 10px;
        padding-left: 10%;
        margin-left: 10px;
        margin-right: 10px; */
    }
h2 {
        text-align: center;
        font-weight: 200;
        /* padding-bottom: 30px; */
    }
p {
    font-size: 20px;
}

i {
    color: rgb(97, 149, 252);
}
small {
    color: rgb(97, 149, 252);
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordChange.vue